module.exports = __webpack_public_path__ + "img/button_home.40e06036.png";